import { render, staticRenderFns } from "./EditDocumentGroup.vue?vue&type=template&id=2776863b"
import script from "./EditDocumentGroup.vue?vue&type=script&lang=js"
export * from "./EditDocumentGroup.vue?vue&type=script&lang=js"
import style0 from "./EditDocumentGroup.vue?vue&type=style&index=0&id=2776863b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports